import React from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type Props = {
  logoUrl?: string;
  rightSlot: React.ReactNode;
  maxWidth?: number;
  onBack?: () => void;
};

export default function ShareboxHeader({
  logoUrl,
  rightSlot,
  maxWidth = 480,
  onBack,
}: Props) {
  const theme = useTheme();

  return (
    <Box component="header" sx={{ position: "sticky", top: 0, zIndex: 10 }}>
      <Box
        sx={{
          maxWidth,
          mx: "auto",
          height: 52,
          boxSizing: "border-box",
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {onBack && (
            <IconButton
              aria-label="back"
              onClick={onBack}
              size="small"
              sx={{ color: "#fff", ml: -1 }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
          {logoUrl ? (
            <img
              src={logoUrl}
              alt=""
              style={{ height: 28, maxHeight: "60%" }}
            />
          ) : (
            !onBack && <Box sx={{ height: 28 }} />
          )}
        </Box>
        <Typography variant="body2" sx={{ color: "#fff", opacity: 0.85 }}>
          {rightSlot}
        </Typography>
      </Box>
    </Box>
  );
}
